import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import myImg from "../../Assets/hero-img-purple.png";
import { Globe } from "../../components/Globe";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import "./About.css"; // your custom CSS file

function About() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("arzankhan994@gmail.com") // replace with your email
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy email: ", err);
      });
  };

  return (
    <section className="about-section" id="about">
      <Container>
        <h2 className="about-heading">About Me</h2>

        <Row className="about-grid">
          {/* Grid 1 - Image & intro */}
          <Col md={6} className="grid-item intro">
            <Tilt>
              <img src={myImg} alt="avatar" className="about-avatar" />
            </Tilt>
            <div className="intro-text">
              <h3>Hi, <span className="purple"> I'm Arzan</span></h3>
              <p>
                Over the last 4 years, I have been developing projects in app development, data analytics, 
                and AI & ML to refine my skills and help organizations grow.
              </p>
            </div>
          </Col>

          {/* Grid 2 - CODE IS CRAFT */}
          <Col md={6} className="grid-item code-craft">
            <h3>CODE IS CRAFT</h3>
            <div className="card-cloud">
              <div className="mini-card" style={{ transform: "rotate(15deg)" }}>
                GRASP
              </div>
              <div className="mini-card" style={{ transform: "rotate(-10deg)" }}>
                SOLID
              </div>
              <div className="mini-card" style={{ transform: "rotate(25deg)" }}>
                SRP
              </div>
              <div className="mini-card" style={{ transform: "rotate(-20deg)" }}>
                Design Patterns
              </div>
              <div className="mini-card" style={{ transform: "rotate(10deg)" }}>
                Design Principles
              </div>
            </div>
          </Col>

          {/* Grid 3 - Time zone / globe */}
          <Col md={6} className="grid-item timezone">
            <h3>Time Zone</h3>
            <p>I'm based on <span className="purple">Mars 🌕</span> and open to remote work worldwide.</p>
            <Globe/>
          </Col>

          {/* Grid 4 - Start a project / email */}
          <Col md={6} className="grid-item start-project">
            <h3>Do you want to start a project together?</h3>
            <button className="email-button" onClick={handleCopyEmail}>
              {copied ? "Copied!" : "Copy Email"}
            </button>
          </Col>
        </Row>

        {/* Social links at the bottom */}
        <Row>
          <Col className="about-social">
            <h4>FIND ME ON</h4>
            <p>
              Feel free to <span className="highlight">connect</span> with me
            </p>
            <ul className="social-links">
              <li>
                <a href="https://github.com/Arzan101" target="_blank" rel="noreferrer">
                  <AiFillGithub />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/" target="_blank" rel="noreferrer">
                  <AiOutlineTwitter />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/arzan-khan-9a9b611ba/" target="_blank" rel="noreferrer">
                  <FaLinkedinIn />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/arzan__khan.__/" target="_blank" rel="noreferrer">
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
